export const primeiraLetraMaiscula = (str: string) => {
  if (!str) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const primeiraLetraMaisculaCadaPalavra = (palavra: string) => {
  return palavra.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const somenteNumeros = (str: string) => {
  return str.replace(/[^\d]/g, '');
};

export const converterParaLowerKebabCase = (str: string) => {
  return str
    .normalize('NFD') // separa acentos
    .replace(/[\u0300-\u036f]/g, '') // remove acentos
    .replace(/ç/g, 'c') // substitui ç por c
    .replace(/Ç/g, 'C') // substitui Ç por C
    .replace(/[^a-zA-Z0-9\s]/g, '') // remove caracteres especiais
    .trim() // remove espaços nas pontas
    .toLowerCase() // converte tudo para minúsculo
    .replace(/\s+/g, '-'); // substitui espaços por hífen
};

export const getCurrentDateTimeString = (daysToAdd: number = 0) => {
  const dataAtual = new Date();

  dataAtual.setDate(dataAtual.getDate() + daysToAdd);

  return dataAtual.toString();
};
